// Must be an interface to extend it.
/* eslint-disable @typescript-eslint/consistent-type-definitions */

import { appendPipe, assert, type Pipe } from './toolkit';

const pipe: Pipe<unknown> = function (this, fn) {
  return appendPipe(fn(this));
};

declare global {
  interface String {
    pipe: Pipe<string>;
  }

  interface Number {
    pipe: Pipe<number>;
  }

  interface Boolean {
    pipe: Pipe<boolean>;
  }

  interface Array<T> {
    pipe: Pipe<T[]>;
  }
}

let isExtended = false;
/**
 * Must call this before any other code runs to extend native JS prototypes.
 */
export function extendNativePrototypes() {
  const types = [String, Number, Boolean, Array] as const;
  types.forEach((t) => {
    if (!isExtended) {
      // TODO: Send notification to team if this fails.
      assert(
        !t.prototype.pipe,
        `${t.name} prototype has pipe implemented natively`,
      );
    }

    // The type doesn't reflect the runtime value here, it could be undefined.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (!t.prototype.pipe) {
      Object.defineProperty(t.prototype, 'pipe', {
        enumerable: false,
        writable: false,
        configurable: false,
        value: pipe,
      });
    }
  });

  isExtended = true;
}
